export default __webpack_public_path__ + "static/media/laptop.912fac34.svg";